import { SupportedLocale } from '@app/core/locale';

function createFormatter(fractionDigits: number, locale: SupportedLocale): Intl.NumberFormat {
    return new Intl.NumberFormat(
        locale,
        {
            style: 'percent',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        },
    );
}

export function createFormatPercentage(roundingPrecision: number, locale: SupportedLocale): (value: number) => string {
    return (value: number) => formatPercentage(
        createFormatter(roundingPrecision, locale),
        value,
    );
}

function formatPercentage(formatter: Intl.NumberFormat, value: number): string {
    return formatter.format(value).replace(' ', '');
}
